import { useEffect, useState } from "react";
import { useTheme } from "next-themes";

export const ThemeTransition = () => {
  const { theme } = useTheme();
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    setIsTransitioning(true);
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [theme]);

  if (!isTransitioning) return null;

  return (
    <div 
      className="fixed inset-0 z-[9999] pointer-events-none"
      style={{
        background: theme === "dark" 
          ? "radial-gradient(circle at center, rgba(34, 40, 56, 0.3) 0%, transparent 70%)"
          : "radial-gradient(circle at center, rgba(255, 255, 255, 0.3) 0%, transparent 70%)",
        animation: "theme-fade-in 0.3s ease-out"
      }}
    />
  );
};
